import React, { Component } from 'react'
import { Row, Col, Badge, Button, Table } from 'react-bootstrap';
import './StyleOrder.css';

export default class Order2 extends Component {
  state = {
    CheckWeightSheet: {
      description: {
        description: {},
      },
    },
    FinancialSheet: {
      description: {
        description: {},
      },
    },
    paidWageSheet: {
    },
    active : [],
  }

  componentWillMount() {
    this.setState({
      CheckWeightSheet : this.props.CheckWeightSheet,
      FinancialSheet : this.props.FinancialSheet,
      paidWageSheet : this.props.paidWageSheet,
    },() => console.log(this.state))
  }
  handleButtonClick = (e,idx) => {
    let { handleButtonClick } = this.props

    switch (e.target.id) {
      case 'true':
        this.setState({
          active: {
            ...this.state.active,
            [idx]:true },
        }, handleButtonClick(true,idx))
        break;
      case 'false':
        this.setState({
          active: {
            ...this.state.active,
            [idx]:false },
        }, handleButtonClick(false,idx))
        break;
    }
  }

  render() {
    let { CheckWeightSheet,FinancialSheet,active,paidWageSheet } = this.state;
    let { handleExtra,handleSubmit } = this.props;
    if( FinancialSheet ){
      return (
        <div>
          {FinancialSheet.description.description.map((data,idx)=>(
            <div className="TopSpace">
              <Row>
                <Col align="center">
                  <h1>Order No : {FinancialSheet.description.requestID}<br /><br /></h1><h3>
                    <Badge variant="primary">License No :<br />{FinancialSheet.description.description.licenseID}</Badge></h3><br />
                  <p>ปริมาณคงเหลือ : 32 ตัน</p>
                </Col>
          
                <Col>Shipper : {FinancialSheet.description.companyID} <br />
                          Supplier : {FinancialSheet.description.requestBy}<br />
                          Ex rice mill / godown: โคมี<br />
                          Quality said tone : {FinancialSheet.description.description.riceTypeID} <br />
                          Vessel : {FinancialSheet.description.description.vehicleName} Destination : {FinancialSheet.description.description.destinationCity} <br />
                          Gross weight : 1,042,496 Kgs<br />
                          Tar weight      :        2,496 Kgs<br />
                          Net weight     : 1,040,000 Kgs<br />
                </Col>
               
              </Row>
            </div>
          ))}
        </div>
      )
    }
    return (
      <div>
        {CheckWeightSheet.description.description.map((data,idx)=>(
          <div>
            <div className="TopSpace">
              <Row>
                <Col align="center">
                  <h1>Order No : {CheckWeightSheet.requestID}<br /><br /></h1><h3>
                    <Badge variant="primary">License No :<br />{data.licenseID}</Badge></h3><br />
                </Col>

                <Col>Shipper : {CheckWeightSheet.description.companyID} <br />
            Supplier : {CheckWeightSheet.description.surveyCompany}<br />
            Ex rice mill / godown: {CheckWeightSheet.surveyLocateName}<br />
            Quality said tone : {data.riceTypeID} <br />
            Vessel : {data.vehicleName} Destination : {data.destinationCity} <br />
            Gross weight : {data.grossWeight} Kgs<br />
            Tar weight      :        {data.grossWeight - data.netWeight} Kgs<br />
            Net weight     : {data.netWeight} Kgs
                </Col>
              </Row>
            </div>
            <Row>
              <Col>
                <Button variant={active[idx] === false ? 'danger' : 'dark'} size="lg" id={'false'} onClick={(e)=>{this.handleButtonClick(e,idx)}} >แก้ไข</Button>
              </Col>
              <Col>
                <Button variant={active[idx] === true ? 'success' : 'dark'} size="lg" id={'true'} onClick={(e)=>{this.handleButtonClick(e,idx)}}>ผ่าน</Button>
              </Col>
            </Row>
          </div>
        ))}
      </div>

    )
  }
}
